import React, { useState } from 'react'
import { hashHistory } from 'react-router'
import { CircularProgress } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { useStyle } from './style'
import * as requests from '../../../lib/requests.es6'

const CustomerSearch = ({ onBack, onCustomerSelect }) => {
  const classes = useStyle()
  const [searchTerm, setSearchTerm] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [hasSearched, setHasSearched] = useState(false)

  const handleChange = e => {
    setSearchTerm(e.target.value)
    setError('')
  }

  const handleSearch = async e => {
    e.preventDefault()
    let term = searchTerm.trim()
    setHasSearched(true)

    if (!term || term.length < 2) {
      setError('Please enter a valid phone number')
      setSearchResults([])
      return
    }

    if (term.startsWith('0')) {
      term = term.substring(1)
    }
    term = '00254' + term

    setLoading(true)
    try {
      const response = await requests.checkCustomerRegistration(term)
      const customer = response.data
      if (customer && customer.guid) {
        setSearchResults([customer])
      } else {
        setSearchResults([])
        setError('No customer found with that phone number')
      }
    } catch (err) {
      setSearchResults([])
      setError('No customer found with that phone number')
    } finally {
      setLoading(false)
    }
  }

  const handleSelectCustomer = customer => {
    if (onCustomerSelect) {
      onCustomerSelect(customer)
    }
    hashHistory.push(`admin/create-quote/${customer.guid}`)
  }

  return (
    <div className={classes.formWrapper}>
      {onBack && (
        <button className={classes.backButton} onClick={onBack}>
          ← Back
        </button>
      )}
      <h2 className={classes.formTitle}>Search Existing Customer</h2>

      <form onSubmit={handleSearch}>
        <div className={classes.formGroup}>
          <label className={classes.label}>Enter Phone Number *</label>
          <input
            type="tel"
            className={classes.input}
            placeholder="e.g., 0722000000"
            value={searchTerm}
            onChange={handleChange}
            disabled={loading}
          />
        </div>

        {error && <div className={classes.error} style={{ marginBottom: '16px' }}>{error}</div>}

        <button
          type="submit"
          className={classes.submitButton}
          disabled={loading}
          style={{
            opacity: loading ? 0.6 : 1,
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? (
            <>
              <CircularProgress size={20} style={{ marginRight: '10px' }} />
              Searching...
            </>
          ) : (
            'Search Customer'
          )}
        </button>
      </form>

      {loading && (
        <div className={classes.loading}>
          <CircularProgress size={30} />
        </div>
      )}

      {searchResults.length > 0 && (
        <div className={classes.searchResults}>
          {searchResults.map(customer => (
            <div
              key={customer.guid}
              className={classes.searchResult}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer'
              }}
              onClick={() => handleSelectCustomer(customer)}
            >
              <div>
                <div style={{ fontWeight: '500' }}>{customer.full_name}</div>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  {customer.msisdn}
                </div>
              </div>
              <ChevronRightIcon style={{ color: '#fba92c', fontSize: '28px' }} />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default CustomerSearch
